import { useEffect } from 'react';
import { PushClient } from '@myapp/common-web-sdk';
import { useAuth } from '../../contexts/AuthContext';

// One client per mounted app. Log live messages in every participating tab.
export default function PushDebugLogger() {
  const { user, loading, isAuthenticated } = useAuth();
  const userId = user?.id || user?.user_id;

  useEffect(() => {
    if (loading || !isAuthenticated || !userId) return undefined;

    const push = new PushClient({
      getUserId: () => String(userId),
      onAuthError: () => console.warn('[push] authentication failed; sign in again'),
    });
    const unsubscribe = [
      push.subscribe('*', (message, meta) => {
        console.info('[push] message received', message, { isLeader: meta.isLeader });
      }),
      push.on('connected', (info) => console.info('[push] connected', info)),
      push.on('leader', ({ isLeader }) => console.info('[push] tab role', { isLeader })),
      push.on('reconnected', () => console.info('[push] reconnected; application data may need refreshing')),
      push.on('resync', () => console.info('[push] resync requested; application data may need refreshing')),
      push.on('disconnected', (info) => console.info('[push] disconnected', info)),
      push.on('auth.failed', () => console.warn('[push] authentication failed')),
      // Do not log Axios errors: their config can contain Authorization headers.
      push.on('error', (info) => console.warn('[push] error', {
        type: info?.type,
        code: info?.code,
      })),
    ];

    console.info('[push] starting live message logger');
    push.connect().catch(() => console.warn('[push] could not start; check login and SDK configuration'));

    return () => {
      unsubscribe.forEach((off) => off());
      push.disconnect();
      console.info('[push] message logger stopped');
    };
  }, [loading, isAuthenticated, userId]);

  return null;
}
